<div class="container-fluid">
	<div class="col-md-12" *ngIf="isLoading"
		style="position: fixed; top: 0; left: 0; width: 100%;height: 100%;    z-index:99;">
		<app-busy [message]="message"></app-busy>
	</div>
	<div class="page_header flex_row">
		<h1 class="heading">Search Correspondence Log</h1>
		<a [routerLink]="['/corspdc/batch']" class="text-secondary pull-right">Correspondence batches</a>
	</div>
	<hr>
	<fieldset class="scheduler-border" style="margin:0px;padding:0px;aria-hidden=true;display:none ;">
		
		
			
				<table class="" style="width:100%!important;margin:0px;padding:0px; border=0" display="none">
					<tr class="rmp-all">
						<td style="width:18%!important;vertical-align:top!important;">
						<!-- 	<select class="form-control form-control-sm" [(ngModel)]="selectedCarrier">
								<option value="0" selected>All carriers</option>
								<option *ngFor="let item of carriers" [ngValue]="item.id">{{item.desc}}</option>
							</select> -->
							<input type="text" style="width:210px!important;height:35px"
             				class="form-control form-control-lg"
             				[(ngModel)]="carrierAccountNumber"
             				placeholder="Filter by account number..."
             				title="Enter the Account number to filter by..."
             				(ngModelChange)="onQueryChanged()">
						</td>
						<td style="vertical-align:top!important;">
							<ul class="list-group" style="margin-left:30px!important;">
								<li class="list-group-item" *ngFor="let item of filter_one">
									<input type="radio" [(ngModel)]="filterUSelected" name="filterUSelected"
										value="{{item.value}}" />
									{{item.key}}
								</li>
							</ul>
						</td>
						<td style="vertical-align:top!important;">
							<ul class="list-group" style="margin-left:30px!important;">
								<li class="list-group-item" *ngFor="let item of filter_two">
									<input type="radio" [(ngModel)]="filterTSelected" name="filterTSelected"
										value="{{item.value}}" />
									{{item.key}}
								</li>
							</ul>
						</td>
						<td style="vertical-align:top!important;width:22%!important;">
							<div class="row" style="margin:1px 1px 0 1px;padding:0px 1px 0 1px;">
								<div class="col-4 rmp-all-c text-right">Date From :&nbsp;</div>
								<div class="col-8 rmp-all">
									<input type="date" style="margin:0px;padding:0px;" [ngModel]="dateFrom"
										(ngModelChange)="dateFrom = $event" name="dateFrom"
										class="form-control form-control-sm" />
								</div>
							</div>
						</td>
						<td style="vertical-align:top!important;width:22%!important;" class="">
							<div class="row" style="margin:0px 1px 0 1px;padding:1px 1px 0 1px;">
								<div class="col-4 rmp-all-c text-right">Date To :&nbsp;</div>
								<div class="col-8 rmp-all">
									<input type="date" [ngModel]="dateTo" (ngModelChange)="dateTo = $event"
										name="dateTo" class="form-control form-control-sm" />
								</div>
							</div>
						</td>
						<td style="vertical-align:top!important;width:10%!important;" class="rmp-all">
							<!--Button with tooltip and no label -->
							
								<button class="main-btn rounded-circle rmp-all" (click)="onReset()" id="btnReset"
									title="Reset filters..." style="margin: 1px auto!important;" rel="tooltip"
									data-placement="top" aria-hidden="true"></button>
									<span class="fa fa-undo fa-2x" style="margin:5.5px auto;color:white!important;"
									aria-hidden="true"></span>
							
							
								<button class="main-btn rounded-circle rmp-all" (click)="onSearch()" id="btnSearch"
									title="Apply filters..." style="margin: 0px auto!important;" rel="tooltip"
									data-placement="top" aria-hidden="true"></button>
									<span class="fa fa-search fa-2x" style="margin:5.5px auto;color:white!important;"
										aria-hidden="true"></span>
								
							
						</td>
					</tr>
				</table>
			
		
	</fieldset>
<app-filter >
</app-filter>
  
  
	<div class="table-responsive">
		<table class="table tbl-stl table-sm custom_table">
			<thead class="thead-inverse">
				<tr class="hd-clpse">
					<th class="tbl-hd-stl">Sent/Rcvd</th>
					<th class="tbl-hd-stl"><i class="fa fa-paperclip" aria-hidden="true"></i></th>
					<th class="tbl-hd-stl">Carrier</th>
					<th class="tbl-hd-stl">Subject</th>
					<th class="tbl-hd-stl text-right">Date</th>
					<!-- <th class="tbl-hd-stl">From</th> -->
					<th class="tbl-hd-stl">To</th>
					<th class="tbl-hd-stl">Application</th>
					<th class="tbl-hd-stl">Permit</th>
					<th class="tbl-hd-stl">Type</th>
				</tr>
			</thead>
			<tbody>
				<tr class="tbl-row click hov"
					*ngFor="let item of logs | orderBy: criteria : direction | paginate: {itemsPerPage:pageSize, currentPage: utility.page ,totalItems: count}"
					(click)="preview(item)"
					[ngClass]="{'clicked':changeClass==item.id, 'un-clicked':changeClass!=item.id}">
					<td class="bfr-end-col">{{item.sent_rcvd}}</td>
					<td class="bfr-end-col"><i [ngClass]="{'fa fa-paperclip':item.hasDoc==true}"
							aria-hidden="true"></i></td>
					<td class="bfr-end-col">{{item.carrierName}}</td>
					<td class="bfr-end-col longtext" title="{{item.subject}}">{{item.subject}}</td>
					<td class="bfr-end-col text-right">{{item.date_sent?.toLocaleString() | date:'y/MM/dd HH:mm:ss'}}</td>
					<!-- <td class="bfr-end-col">{{item.person_from}}</td> -->
					<td class="bfr-end-col longtext" title="{{item.subject}}">{{item.persons_to}}</td>
					<td class="bfr-end-col">{{item.app_id_permit_type_code}}</td>
					<td class="bfr-end-col">{{item.permit_num}}</td>
					<td class="bfr-end-col end-col">{{item.comm_type}}</td>
				</tr>
			</tbody>
			<tfoot>
				<tr *ngIf="count > 1" class="pagination_row">
					<td colspan="9" class="rm-brd">
						<div class="row">
							<div class="col-4">
								<div class="input-group mb-3 rm-brd"
									style="width:125px!important;height:30px!important;">
									<div class="input-group-prepend">
										<label class="input-group-text form-control-sm show-h" for="show-id"
											>Show:</label>
									</div>
									<select class="form-control form-control-sm show-h" id="show-id"
										[(ngModel)]="pageSize" (change)="onChange()">
										<option *ngFor="let key of utility.pageItems" [ngValue]="key">{{key}}
										</option>
									</select>
								</div>
							</div>
							<div class="col-8 text-right">
								<pagination-controls (pageChange)="utility.page = onNextOrPrevious($event)"></pagination-controls>
							</div>
						</div>
					</td>
				</tr>
				<tr *ngIf="isEmpty">
					<td colspan="4" class="rm-brd">
						<span class="text-info text-small">No Correspondence Logs found.</span>
					</td>
				</tr>
			</tfoot>
		</table>
	</div>
	<!-- <fieldset class="scheduler-border" style="margin:0px;padding:0px;">
		<legend class="scheduler-border tsk-display">Correspondence Log</legend>
	</fieldset> -->
	<fieldset class="scheduler-border" style="margin:0px;padding:0px;" *ngIf="isShown">
		<legend class="scheduler-border tsk-display">Message Preview</legend>
		<div class="col-12" style="margin:0px!important;padding:0px!important;">
			<div class="row">
				<div class="col-12">
					<h4 class="text-dark">{{subject}}</h4>
				</div>
				<div class="col-8" style="font-size:14px;"><span class="text-muted">{{from}}</span></div>
				<div class="col-4 text-right" style="font-size:11px;"><span class="text-muted">{{dateSent |
						date:'y/MM/dd HH:mm:ss'}}</span></div>
				<div class="col-12 text-small text-primary" style="margin-bottom:6px;font-size:12px;">
					To/CC:<span>{{toCC}}</span></div>
				<div class="col-4 text-left" style="font-size:11px;"><span class="text-dark">Carrier :
						{{careerName||'None'}}</span></div>
				<div class="col-4 text-center" style="font-size:11px;"><span class="text-dark">Application : {{appCode
						||'None'}}</span></div>
				<div class="col-4 text-right" style="font-size:11px;"><span class="text-dark">Permit :
						{{permNum||'None'}}</span></div>
				<div class="col-12 text-small text-dark" style="margin:10px auto;">
					<div id="text-body" [innerHTML]="bodyText" style="margin:2px;padding:10px;" class="form-control">
					</div>
				</div>
				<div class="col-12 rmp-all">
					<!--Button with label and tooltip -->
					<div class="cover-x pull-right">
						<div class="main-btn rounded-circle" (click)="closeBody()" title="Close"
							style="margin: 1px auto;" rel="tooltip" data-placement="top">
							<span class="fa fa-times fa-2x" style="margin:5.5px auto;color:white!important;"
								aria-hidden="true"></span>
						</div>
						<div class="lbl-app" style="margin: 1px auto;">
							<span>Close</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</div>